import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { KYCStatus } from '~/api/KYCStatus';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';

import { userStore } from '~/stores';

import { LOYALTY_PAGE_URL } from './constants';
import { LoyaltyMenuItemProps } from './interfaces';
import styles from './LoyaltyMenuItem.module.scss';

export default observer((props: PropsWithChildren<LoyaltyMenuItemProps>) => {
  const { t } = useTranslation();

  const {
    className,
    children,
    labelClassName,
    onClick,
    link = LOYALTY_PAGE_URL,
    label = t('loyalty'),
    icon = 'coins',
    iconSize = 24,
    hideIcon = false,
  } = props;

  if (userStore.loyaltyPointsStore.showLoyaltyPointsOnFrontend !== true) {
    return <></>;
  }

  if (
    company.needKycCheck &&
    userStore.personalData?.kycStatus !== KYCStatus.Verified
  ) {
    return <></>;
  }

  return (
    <Link
      to={link}
      className={classes([styles.root, className])}
      onClick={onClick}
    >
      {!hideIcon && <Icon type={icon} size={iconSize} />}
      <p className={classes([styles.label, labelClassName])}>{label}</p>
      {children}
    </Link>
  );
});
